import React, { useState, useRef, useEffect } from "react"
import { Link } from "gatsby"
import styled, { keyframes } from "styled-components"
import publicIp from "public-ip"
import { size, family } from "../../elements/font"

import Story from "../Story"
import { useStaticQuery, graphql } from "gatsby"

const ContainerIframe = styled.div`
  margin: 10px 40px;
  margin-bottom: 16px;
  border-radius: 48px;
  position: sticky;
  margin-left: 6vw;
  top: 20vh;
  background-color: red;
  height: 55vh;
  border-radius: 48px;
  box-shadow: 2px 11px 20px 7px rgb(0 0 0 / 33%);
  @media screen and (max-width: 815px) {
    position: static;
    height: 45vh;
    margin-left: 40px;
    border-radius: 40px;
  }
`

const TextService = styled.div`
  margin: 20px;
  line-height: 1.4;
  letter-spacing: 4px;
  font-size: 2.2rem;
  max-width: 17vw;

  @media screen and (max-width: 815px) {
    font-size: 1rem;
    max-width: 26vw;
    margin: 4px;
    line-height: 1.2;
    letter-spacing: 0px;
  }
`

const StoryVideoAskContainer = styled.div`
  position: sticky;
  top: 0px;
  width: 40%;
  @media screen and (max-width: 815px) {
    width: 100%;
    position: static;
  }
`

const GradientBorder = styled.div`
  background: linear-gradient(
    268.2deg,
    #1e4ed1 0.83%,
    #264aad 0.84%,
    #002487 99.13%
  );
  padding: 4px;
  border-radius: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ExtensionContainer = styled.div`
  height: 100vh;
  padding-top: 120px;
  overflow: scroll;
  position: fixed;
  background-color: white;
  top: 0;
  bottom: 0;
  transition: all 0.12s ease-out;
  width: 100vw;
  ${props => (props.show ? "left: 0px;" : "left: -100vw;")}
  z-index: 599;
  display: flex;
  flex-wrap: wrap;
  font-family: ${family.Alata};

  @media screen and (max-width: 815px) {
    padding-top: 70px;
    display: block;
  }
`

const StoryContainer = styled.div`
  display: flex;
  position: sticky;
  top: 28px;
  flex-grow: 1;
  margin-right: 62%;
  z-index: 999;
  overflow-x: scroll;
  margin-left: 6vw;
  padding: 12px 0px;
  padding-bottom: 6px;
  padding-top: 24px;
  @media screen and (max-width: 815px) {
    background-color: #f8f8f8;
    width: 100%;
    margin-left: 0px;
    box-shadow: -1px 1px 3px #cfcfcf;
    padding-top: 12px;
  }
`

const ServiceContainer = styled.div`
  flex-grow: 1;
  display: grid;
  position: relative;
  grid-template-columns: 1fr 1fr;
  grid-gap: 32px 24px;
  padding-left: 8%;
  margin-right: 6vw;
  max-width: 52vw;
  margin-top: -108px;

  @media screen and (max-width: 815px) {
    padding-left: 0px;
    padding: 20px 40px;
    padding-bottom: 70px;
    width: 100%;
    grid-gap: 24px 12px;
    max-width: none;
    margin-top: 20px;
  }
`

const ServiceLink = styled.a`
  background-size: cover;
  height: 380px;
  background-color: gray;
  overflow-hidden: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  background-image: url('${props => props.url && props.url}'); 
  color: white;
  padding: 0px 2px;
  max-width: 25vw;
  text-align: center;
  font-size: 1.75rem;

  

  text-decoration: none;
  border: 6px solid #676767;
  border-radius: 40px;
  &:hover{
    color: grey;
  }
  @media screen and (max-width: 815px) {
    height: 50vw;
    border-radius: 12px;
    font-size: 1.4rem !important;
    max-width: none;
   
    border: 4px solid #676767;
 
  }
`

const BtnStoryContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: 0;
  min-width: 90px;
  max-width: 90px;
  height: 100px;
  text-overflow: ellipsis;
  margin-left: -8px;
  margin-right: 20px;
  @media screen and (max-width: 815px) {
    margin-left: 4px;
    margin-right: 0px;
  }
`

const BtnStory = styled.div`
  border-radius: 99px;
  height: 68px;
  width: 68px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-size: cover;
  background-color: white;
`

const ToggleBtnContainer = styled.div`
  margin-top: 5px;
  width: 90px;
  background-color: #1f4ed2;
  border-radius: 50px;
  padding: 5px;
  transition: all 0.2s ease-out;
  &:hover {
    opacity: 0.8;
  }

  ${props =>
    props.active &&
    `
  background-color: #D83654;
  padding-left: 50px;
  `}
`
const ToggleBtnContent = styled.div`
  height: 36px;
  width: 36px;
  background-color: white;
  border-radius: 50px;
`

const Navigation = styled.header`
  z-index: 900;
  position: fixed;
  top: 30px;
  left: 0;
  width: 100%;
  padding: 25px 8vw;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  ${props => props.active && `background-color: white;`}

  @media screen and (max-width: 815px) {
    padding: 10px 5vw;
    ${props => props.hasScrolled && `top: 30px;`}
    width: 100vw;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.03);
    background: rgba(255, 255, 255, 0.98);
  }
`
const LogoLink = styled(Link)`
  z-index: 2001;
  top: calc(25px + 25px + 54px / 2.5);

  left: 6vw;
  position: fixed;
  text-decoration: none;
  max-width: 130px;
  width: 7vw;
  mix-blend-mode: exclusion;
  span {
    position: absolute;
    bottom: 66%;
    left: 105%;
    transform: rotate(-90deg);
    transform-origin: center center;
    font-family: Alata, sans-serif;
    font-size: ${size.S};
    line-height: ${size.S};
    transition: 0.5s cubic-bezier(0.17, 0.67, 0.16, 1.28) transform;
    color: #fff;
    &.green {
      color: #88b008;
    }
  }
  &.green {
    mix-blend-mode: darken;
  }
  &:hover {
    span {
      transform: rotate(0deg);
    }
  }
  svg {
    width: 100%;
  }
  @media only screen and (max-width: 900px) {
    width: 20%;
    top: 55px;
    svg {
      width: 100%;
    }
  }
`
const HeaderString = styled.span`
  font-family: Alata, sans-serif;
  font-weight: 400;
  mix-blend-mode: exclusion;
  background: inherit;
  font-size: ${size.XS};
  line-height: 25px;
  position: fixed;
  top: calc(44px + 16px);
  z-index: 150;
  color: #fff;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none;
  transition: 0.3s ease opacity;
  ${props =>
    props.green &&
    `
        background: #50489f;
        background: linear-gradient(-90deg, #50489f 35%, #9673ab 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    `}
  &.scrolled {
    opacity: 1;
    pointer-events: all;
  }
  &.disapear {
    opacity: 0;
  }
  @media screen and (max-width: 815px) {
    display: none;
  }
`

const HoursAndLocation = styled.div`
  position: fixed;
  display: flex;
  z-index: 200;
  text-align: right;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  top: 120px;
  right: 8vw;
  width: 201.55px;
  transition: 0.2s ease;
  opacity: ${props => (props.displayLocal ? "0" : "1")};
  pointer-events: ${props => (props.displayLocal ? "none" : "all")};
  @media only screen and (max-width: 900px) {
    top: 104px;
    width: 150px;
    right: 5vw;
  }
  &.hide {
    opacity: 0;
    pointer-events: none;
  }
`
const TextInside = styled.span`
  color: #000;
  font-family: Space Mono, sans-serif;
  font-size: 0.54rem;
  line-height: 12px;
  letter-spacing: 0.12em;
  @media only screen and (max-width: 900px) {
    font-size: 0.43rem;
    white-space: nowrap;
  }
`

const ToogleBtn = ({ active, press }) => (
  <ToggleBtnContainer active={active} onClick={press}>
    <ToggleBtnContent active={active} />
  </ToggleBtnContainer>
)

const Header = ({
  children,
  hasScrolled = false,
  connexionClick = null,
  blackLogo = true,
  noMenu = false,
  pageMenu = 0,
  contactLink = "",
}) => {
  const pageMenuValue =
    pageMenu !== null || pageMenu !== undefined ? pageMenu : 0
  const [appear, setAppear] = useState(false)
  const [City, setCity] = useState(null)
  const [Region, setRegion] = useState(null)
  const [clock, setclock] = useState(null)
  const [params, setparams] = useState()
  const [incrementArray, setincrementArray] = useState(0)
  const menu = useRef(null)
  const [activeStory, setactiveStory] = useState(false)
  const [showExtension, setshowExtension] = useState(false)
  let arrayOfStrings
  const [displayLocal, setlocal] = useState(false)
  Array.isArray(children)
    ? (arrayOfStrings = children)
    : (arrayOfStrings = [""])
  let menuMobile = true
  useEffect(() => {
    window.location.search.substr(1) == "menu" && setshowExtension(true)
  }, [])

  useEffect(() => {
    const body = document.querySelector("body")
    if (showExtension) {
      body.style.overflow = "hidden"
      body.style.maxHeight = "100vh"
    } else {
      body.style.overflow = "scroll"
      body.style.maxHeight = "none"
    }
  }, [showExtension])

  useEffect(() => {
    setAppear(true)
    const headerMenu = menu.current
    const blockToIncrement = document.querySelectorAll(".changeHeaderString")
    let lastScrollTop = 0
    let previousIncrement = 0
    let passedDiv = []
    window.addEventListener("scroll", () => {
      document.body.getBoundingClientRect().y < -100
        ? setlocal(true)
        : setlocal(false)
      if (
        document.body.getBoundingClientRect().y < -200 &&
        menuMobile == true
      ) {
        menuMobile = false
        setAppear(false)
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      for (let i = 0; i < blockToIncrement.length; i++) {
        if (blockToIncrement[i].getBoundingClientRect().y < 50) {
          passedDiv[i] = 1
          const numberPassedDiv = passedDiv.reduce((a, b) => a + b, 0)
          if (scrollTop > lastScrollTop && i > previousIncrement) {
            previousIncrement += 1
            // downscroll code
            document.querySelector(".headerString").classList.add("disapear")
            setTimeout(() => {
              document
                .querySelector(".headerString")
                .classList.remove("disapear")
              setincrementArray(i)
            }, 300)
          } else if (scrollTop < lastScrollTop && i === numberPassedDiv - 1) {
            // upscroll code
            if (i < previousIncrement) {
              previousIncrement -= 1
              document.querySelector(".headerString").classList.add("disapear")
              setTimeout(() => {
                document
                  .querySelector(".headerString")
                  .classList.remove("disapear")
                setincrementArray(i)
              }, 300)
            }
          }
        } else {
          passedDiv[i] = 0
        }
      }
      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop
    })
    const callInfos = async data => {
      const endpoint = `https://www.iplocate.io/api/lookup/${data}`
      fetch(endpoint, {
        dataType: "multipart/form-data",
      })
        .then(res => res.json())
        .then(data => {
          setRegion(`, ${data.subdivision}`)
          setCity(data.city)
        })
    }
    const findIp = async () => {
      await publicIp
        .v4()
        .then(data => {
          callInfos(data)
        })
        .catch(() => null)
    }
    findIp()
    const date = new Date()
      .toLocaleTimeString()
      .replace("AM", "")
      .replace("PM", "")
    setclock(date)
    const updateClock = setInterval(() => {
      const dateAM = new Date()
        .toLocaleTimeString()
        .replace("AM", "")
        .replace("PM", "")
      setclock(dateAM)
    }, 1000)
    if (headerMenu) {
      headerMenu.addEventListener("mouseleave", () =>
        setTimeout(() => {
          setAppear(false)
        }, 1000)
      )
    }
    if (window.innerWidth > 768) {
      setAppear(true)
    }
    return () => {
      if (headerMenu) {
        headerMenu.removeEventListener("mouseleave", () =>
          setTimeout(() => {
            setAppear(false)
          }, 1000)
        )
        clearInterval(updateClock)
        window.removeEventListener("scroll", () => {
          document.body.getBoundingClientRect().y < -30
            ? setlocal(true)
            : setlocal(false)
        })
      }
    }
  }, [])

  const data = useStaticQuery(graphql`
    query {
      prismicStory {
        data {
          service {
            link {
              url
            }
            service_name {
              text
            }
            image_service {
              url
            }
          }
          stories {
            embed_story {
              url
            }
            miniature {
              url
            }
            story_name {
              text
            }
          }
          videoask {
            embed_url
          }
        }
      }
    }
  `)

  const response = data.prismicStory.data
  return (
    <>
      <ExtensionContainer show={showExtension}>
        <StoryContainer>
          {response.stories.map((s, i) => (
            <BtnStoryContainer>
              <GradientBorder>
                <BtnStory
                  onClick={() => setactiveStory(s.embed_story.url)}
                  style={{ backgroundImage: `url("${s.miniature.url}")` }}
                ></BtnStory>
              </GradientBorder>
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  textOverflow: "ellipsis",
                  color: "#222222",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  fontSize: "0.9rem",
                }}
              >
                {s.story_name[0].text}
              </div>
            </BtnStoryContainer>
          ))}
        </StoryContainer>
        <StoryVideoAskContainer>
          <ContainerIframe>
            <iframe
              title="videoAsk"
              src={response.videoask.embed_url} // allow="camera *; microphone *; autoplay *; encrypted-media *; fullscreen *; display-capture *;"
              style={{
                width: "100%",
                minHeight: "100%",
                position: "relative",
                margin: "0 auto",
                display: "block",
                borderRadius: 40,
                marginTop: 12,
                marginBottom: 12,
                border: "none",
              }}
            ></iframe>
          </ContainerIframe>
        </StoryVideoAskContainer>
        <ServiceContainer>
          {response.service.map(s => (
            <ServiceLink
              target={s.link.target}
              href={s.link.url}
              url={s.image_service.url}
            >
              <TextService>
                {" "}
                {s.service_name[0] ? s.service_name[0].text : null}
              </TextService>
            </ServiceLink>
          ))}
          <p
            style={{
              gridColumn: "span 2",
              width: "100%",
              textAlign: "center",
              paddingTop: 40,
              fontFamily: "Space Mono",
              fontSize: "0.8rem",
            }}
          >
            2025 novlini. All rights reserved.
          </p>
        </ServiceContainer>
      </ExtensionContainer>
      {activeStory ? (
        <Story url={activeStory} close={() => setactiveStory(null)} />
      ) : null}
      {activeStory ? null : (
        <LogoLink
          to="/"
          hasScrolled={hasScrolled}
          className={blackLogo ? "click" : "green click"}
        >
          {blackLogo == true ? (
            <svg
              width="134"
              height="30"
              viewBox="0 0 134 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="#fff">
                <path d="M0.698 11.4633H4.726L4.764 14.6553C5.24533 13.5913 6.00533 12.7173 7.044 12.0333C8.08267 11.3493 9.29867 11.0073 10.692 11.0073C12.4907 11.0073 13.8713 11.3873 14.834 12.1473C15.7967 12.8819 16.4427 13.9206 16.772 15.2633C17.1013 16.6059 17.266 18.3539 17.266 20.5073V28.9053H13.162V20.6213C13.162 18.4173 12.9467 16.8339 12.516 15.8713C12.0853 14.8833 11.1987 14.3893 9.856 14.3893C9.096 14.3893 8.32333 14.6299 7.538 15.1113C6.75267 15.5673 6.094 16.2386 5.562 17.1253C5.05533 18.0119 4.802 19.0506 4.802 20.2413L4.802 28.9053H0.698L0.698 11.4633ZM34.4874 29.2853C32.6888 29.2853 31.0928 28.8799 29.6994 28.0693C28.3061 27.2586 27.2294 26.1566 26.4694 24.7633C25.7094 23.3699 25.3294 21.8246 25.3294 20.1273C25.3294 18.4553 25.6968 16.9226 26.4314 15.5293C27.1914 14.1359 28.2681 13.0339 29.6614 12.2233C31.0548 11.4126 32.6634 11.0073 34.4874 11.0073C36.3114 11.0073 37.9074 11.4126 39.2754 12.2233C40.6688 13.0339 41.7328 14.1359 42.4674 15.5293C43.2274 16.9226 43.6074 18.4553 43.6074 20.1273C43.6074 21.8246 43.2274 23.3699 42.4674 24.7633C41.7074 26.1566 40.6308 27.2586 39.2374 28.0693C37.8694 28.8799 36.2861 29.2853 34.4874 29.2853ZM34.6014 25.9413C36.0708 25.9413 37.2234 25.3966 38.0594 24.3073C38.9208 23.2179 39.3514 21.8499 39.3514 20.2033C39.3514 18.5566 38.8954 17.1759 37.9834 16.0613C37.0714 14.9213 35.8681 14.3513 34.3734 14.3513C32.9294 14.3513 31.7641 14.9086 30.8774 16.0233C30.0161 17.1379 29.5854 18.5313 29.5854 20.2033C29.5854 21.8246 30.0541 23.1926 30.9914 24.3073C31.9288 25.3966 33.1321 25.9413 34.6014 25.9413ZM49.0162 11.4633H53.6902L57.4522 19.3293L58.6682 22.4833L59.8842 19.3293L63.6082 11.4633H68.1682L59.0102 28.9053H58.2122L49.0162 11.4633ZM74.9322 0.975273H78.9982V28.9053H74.9322V0.975273ZM88.8622 11.4633H93.1182V28.9053H88.8622V11.4633ZM90.9522 8.19527C90.1668 8.19527 89.5082 7.92927 88.9762 7.39727C88.4442 6.86527 88.1782 6.20661 88.1782 5.42127C88.1782 4.71194 88.4442 4.10394 88.9762 3.59727C89.5082 3.09061 90.1668 2.83727 90.9522 2.83727C91.7122 2.83727 92.3582 3.09061 92.8902 3.59727C93.4222 4.10394 93.6882 4.71194 93.6882 5.42127C93.6882 6.20661 93.4222 6.86527 92.8902 7.39727C92.3835 7.92927 91.7375 8.19527 90.9522 8.19527ZM102.6 11.4633H106.628L106.666 14.6553C107.148 13.5913 107.908 12.7173 108.946 12.0333C109.985 11.3493 111.201 11.0073 112.594 11.0073C114.393 11.0073 115.774 11.3873 116.736 12.1473C117.699 12.8819 118.345 13.9206 118.674 15.2633C119.004 16.6059 119.168 18.3539 119.168 20.5073V28.9053H115.064V20.6213C115.064 18.4173 114.849 16.8339 114.418 15.8713C113.988 14.8833 113.101 14.3893 111.758 14.3893C110.998 14.3893 110.226 14.6299 109.44 15.1113C108.655 15.5673 107.996 16.2386 107.464 17.1253C106.958 18.0119 106.704 19.0506 106.704 20.2413V28.9053H102.6V11.4633ZM128.562 11.4633H132.818V28.9053H128.562V11.4633ZM130.652 8.19527C129.866 8.19527 129.208 7.92927 128.676 7.39727C128.144 6.86527 127.878 6.20661 127.878 5.42127C127.878 4.71194 128.144 4.10394 128.676 3.59727C129.208 3.09061 129.866 2.83727 130.652 2.83727C131.412 2.83727 132.058 3.09061 132.59 3.59727C133.122 4.10394 133.388 4.71194 133.388 5.42127C133.388 6.20661 133.122 6.86527 132.59 7.39727C132.083 7.92927 131.437 8.19527 130.652 8.19527Z" />
              </g>
            </svg>
          ) : (
            <svg
              width="134"
              height="30"
              viewBox="0 0 134 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.698 11.4633H4.726L4.764 14.6553C5.24533 13.5913 6.00533 12.7173 7.044 12.0333C8.08267 11.3493 9.29867 11.0073 10.692 11.0073C12.4907 11.0073 13.8713 11.3873 14.834 12.1473C15.7967 12.8819 16.4427 13.9206 16.772 15.2633C17.1013 16.6059 17.266 18.3539 17.266 20.5073V28.9053H13.162V20.6213C13.162 18.4173 12.9467 16.8339 12.516 15.8713C12.0853 14.8833 11.1987 14.3893 9.856 14.3893C9.096 14.3893 8.32333 14.6299 7.538 15.1113C6.75267 15.5673 6.094 16.2386 5.562 17.1253C5.05533 18.0119 4.802 19.0506 4.802 20.2413L4.802 28.9053H0.698L0.698 11.4633ZM34.4874 29.2853C32.6888 29.2853 31.0928 28.8799 29.6994 28.0693C28.3061 27.2586 27.2294 26.1566 26.4694 24.7633C25.7094 23.3699 25.3294 21.8246 25.3294 20.1273C25.3294 18.4553 25.6968 16.9226 26.4314 15.5293C27.1914 14.1359 28.2681 13.0339 29.6614 12.2233C31.0548 11.4126 32.6634 11.0073 34.4874 11.0073C36.3114 11.0073 37.9074 11.4126 39.2754 12.2233C40.6688 13.0339 41.7328 14.1359 42.4674 15.5293C43.2274 16.9226 43.6074 18.4553 43.6074 20.1273C43.6074 21.8246 43.2274 23.3699 42.4674 24.7633C41.7074 26.1566 40.6308 27.2586 39.2374 28.0693C37.8694 28.8799 36.2861 29.2853 34.4874 29.2853ZM34.6014 25.9413C36.0708 25.9413 37.2234 25.3966 38.0594 24.3073C38.9208 23.2179 39.3514 21.8499 39.3514 20.2033C39.3514 18.5566 38.8954 17.1759 37.9834 16.0613C37.0714 14.9213 35.8681 14.3513 34.3734 14.3513C32.9294 14.3513 31.7641 14.9086 30.8774 16.0233C30.0161 17.1379 29.5854 18.5313 29.5854 20.2033C29.5854 21.8246 30.0541 23.1926 30.9914 24.3073C31.9288 25.3966 33.1321 25.9413 34.6014 25.9413ZM49.0162 11.4633H53.6902L57.4522 19.3293L58.6682 22.4833L59.8842 19.3293L63.6082 11.4633H68.1682L59.0102 28.9053H58.2122L49.0162 11.4633ZM74.9322 0.975273H78.9982V28.9053H74.9322V0.975273ZM88.8622 11.4633H93.1182V28.9053H88.8622V11.4633ZM90.9522 8.19527C90.1668 8.19527 89.5082 7.92927 88.9762 7.39727C88.4442 6.86527 88.1782 6.20661 88.1782 5.42127C88.1782 4.71194 88.4442 4.10394 88.9762 3.59727C89.5082 3.09061 90.1668 2.83727 90.9522 2.83727C91.7122 2.83727 92.3582 3.09061 92.8902 3.59727C93.4222 4.10394 93.6882 4.71194 93.6882 5.42127C93.6882 6.20661 93.4222 6.86527 92.8902 7.39727C92.3835 7.92927 91.7375 8.19527 90.9522 8.19527ZM102.6 11.4633H106.628L106.666 14.6553C107.148 13.5913 107.908 12.7173 108.946 12.0333C109.985 11.3493 111.201 11.0073 112.594 11.0073C114.393 11.0073 115.774 11.3873 116.736 12.1473C117.699 12.8819 118.345 13.9206 118.674 15.2633C119.004 16.6059 119.168 18.3539 119.168 20.5073V28.9053H115.064V20.6213C115.064 18.4173 114.849 16.8339 114.418 15.8713C113.988 14.8833 113.101 14.3893 111.758 14.3893C110.998 14.3893 110.226 14.6299 109.44 15.1113C108.655 15.5673 107.996 16.2386 107.464 17.1253C106.958 18.0119 106.704 19.0506 106.704 20.2413V28.9053H102.6V11.4633ZM128.562 11.4633H132.818V28.9053H128.562V11.4633ZM130.652 8.19527C129.866 8.19527 129.208 7.92927 128.676 7.39727C128.144 6.86527 127.878 6.20661 127.878 5.42127C127.878 4.71194 128.144 4.10394 128.676 3.59727C129.208 3.09061 129.866 2.83727 130.652 2.83727C131.412 2.83727 132.058 3.09061 132.59 3.59727C133.122 4.10394 133.388 4.71194 133.388 5.42127C133.388 6.20661 133.122 6.86527 132.59 7.39727C132.083 7.92927 131.437 8.19527 130.652 8.19527Z"
                fill="url(#paint0_linear)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear"
                  x1="5"
                  y1="45.9999"
                  x2="126.5"
                  y2="45.9999"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#AFB760" />
                  <stop offset="0.707283" stopColor="#88B007" />
                  <stop offset="1" stopColor="#698C54" />
                </linearGradient>
              </defs>
            </svg>
          )}
          <span className={blackLogo ? "" : "green"}>&reg;</span>
        </LogoLink>
      )}
      <HeaderString
        green={!blackLogo}
        className={hasScrolled ? "scrolled headerString" : "headerString"}
      >
        {arrayOfStrings[incrementArray]}
      </HeaderString>
      <Navigation hasScrolled={hasScrolled} active={showExtension}>
        <ToogleBtn
          press={() => setshowExtension(!showExtension)}
          active={showExtension}
        />
      </Navigation>

      <HoursAndLocation
        className={hasScrolled ? "hide" : ""}
        displayLocal={displayLocal}
      >
        <TextInside>Current local time {clock}</TextInside>
        {City !== null ? (
          <TextInside>
            {City}
            {Region}
          </TextInside>
        ) : null}
      </HoursAndLocation>
    </>
  )
}

export { Header }
